"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TabPanels = function (props) {
    var children = props.children, className = props.className;
    return react_1.default.createElement("div", { className: "tabs__panels " + (className || '') }, children);
};
exports.default = TabPanels;
//# sourceMappingURL=TabPanels.js.map